// extracted by mini-css-extract-plugin
export default {"quote":"QuoteNodeView_quote__eChlq"};